// Staff copy shared by every staff screen, in the three languages a branch in
// Azerbaijan works in.
// Native review pending (az, ru): the Azerbaijani and Russian here are a first
// draft. Change a phrase in all three languages at once, never in one.
import type { Phrase } from '../staffText'

export const common = {
  'common.cancel': { en: 'Cancel', az: 'Ləğv et', ru: 'Отмена' },
  'common.save': { en: 'Save', az: 'Yadda saxla', ru: 'Сохранить' },
  'common.saving': { en: 'Saving…', az: 'Yadda saxlanılır…', ru: 'Сохранение…' },
  'common.saved': { en: 'Saved.', az: 'Yadda saxlanıldı.', ru: 'Сохранено.' },
  'common.back': { en: 'Back', az: 'Geri', ru: 'Назад' },
  'common.signOut': { en: 'Sign out', az: 'Çıxış', ru: 'Выйти' },
  'common.remove': { en: 'Remove', az: 'Sil', ru: 'Удалить' },
  'common.add': { en: 'Add', az: 'Əlavə et', ru: 'Добавить' },
  'common.keep': { en: 'Keep', az: 'Saxla', ru: 'Оставить' },
  'common.clear': { en: 'Clear', az: 'Təmizlə', ru: 'Очистить' },
  'common.delete': { en: 'Delete', az: 'Sil', ru: 'Удалить' },
  'common.choose': { en: 'Choose…', az: 'Seçin…', ru: 'Выберите…' },
  'common.nothingToChoose': { en: 'Nothing to choose from', az: 'Seçmək üçün heç nə yoxdur', ru: 'Выбирать не из чего' },
  'common.reading': { en: 'Reading…', az: 'Oxunur…', ru: 'Загрузка…' },
  'common.loading': { en: 'Loading…', az: 'Yüklənir…', ru: 'Загрузка…' },
  'common.chooseFile': { en: 'Choose a file…', az: 'Fayl seçin…', ru: 'Выберите файл…' },
  'common.noFileChosen': { en: 'No file chosen', az: 'Fayl seçilməyib', ru: 'Файл не выбран' },
  'common.fileNotAccepted': {
    en: '{name} is not a kind of file this takes; choose another.',
    az: '{name} burada qəbul olunan fayl növü deyil; başqasını seçin.',
    ru: 'Файл {name} здесь не принимается: выберите другой.',
  },
  'common.reload': { en: 'Reload', az: 'Yenidən yüklə', ru: 'Обновить' },
  'common.copied': { en: 'Copied', az: 'Kopyalandı', ru: 'Скопировано' },
  'common.yes': { en: 'Yes', az: 'Bəli', ru: 'Да' },
  'common.no': { en: 'No', az: 'Xeyr', ru: 'Нет' },
  'common.notSet': { en: 'Not set', az: 'Təyin edilməyib', ru: 'Не задано' },
  'common.noBranchesYet': { en: 'No branches yet', az: 'Hələ filial yoxdur', ru: 'Отделений пока нет' },
  'common.noBranchAvailable':{ en: 'No branch is available to this account.', az: 'Bu hesab üçün heç bir filial əlçatan deyil.', ru: 'Для этой учётной записи нет доступных отделений.' },
  'common.noAccessPage': { en: 'Your role cannot open this page.', az: '', ru: '' },
  'common.unreachable': { en: 'The server could not be reached.', az: 'Serverlə əlaqə qurmaq mümkün olmadı.', ru: 'Не удалось связаться с сервером.' },
  'common.branch': { en: 'Branch', az: 'Filial', ru: 'Отделение' },
  'common.organisation': { en: 'Organisation', az: 'Təşkilat', ru: 'Организация' },
  'common.allOrganisations': { en: 'All organisations', az: '', ru: '' },
  'common.from': { en: 'From', az: 'Başlanğıc', ru: 'С' },
  'common.to': { en: 'To', az: 'Son', ru: 'По' },
  'common.code': { en: 'Code', az: 'Kod', ru: 'Код' },
  'common.name': { en: 'Name', az: 'Ad', ru: 'Название' },
  'common.retired': { en: 'retired', az: 'istifadədən çıxarılıb', ru: 'выведен из работы' },
  'common.retiredPill': { en: 'Retired', az: 'İstifadədən çıxarılıb', ru: 'Выведен из работы' },
  'common.unsaved': { en: 'Unsaved', az: 'Yadda saxlanmayıb', ru: 'Не сохранено' },

  // Roles, as the top bar and the People screen name them. An organisation's own
  // roles (admin, supervisor, counter, reception, …) are its own data now —
  // named by OrgRole.name, not a fixed phrase — so only the two machine kinds
  // and the installation's own owner stay here.
  'common.role.superadmin': { en: 'Installation administrator', az: 'Quraşdırma administratoru', ru: 'Администратор установки' },
  'common.role.kiosk': { en: 'Kiosk', az: 'Kiosk', ru: 'Киоск' },
  'common.role.display': { en: 'Main display', az: 'Zal ekranı', ru: 'Табло' },

  // What a ticket is doing.
  'common.state.waiting': { en: 'Waiting', az: 'Gözləyir', ru: 'Ожидает' },
  'common.state.called': { en: 'Called', az: 'Çağırılıb', ru: 'Вызван' },
  'common.state.serving': { en: 'Serving', az: 'Xidmətdə', ru: 'Обслуживается' },
  'common.state.wrapup': { en: 'Wrap-up', az: 'Yekunlaşdırma', ru: 'Завершение' },
  'common.state.parked': { en: 'Parked', az: 'Kənara qoyulub', ru: 'Отложен' },
  'common.state.no_show': { en: 'No-show', az: 'Gəlmədi', ru: 'Не явился' },
  'common.state.closed': { en: 'Closed', az: 'Bağlanıb', ru: 'Закрыт' },
  'common.state.void': { en: 'Void', az: 'Ləğv edilib', ru: 'Аннулирован' },
  'common.priority': { en: 'Priority', az: 'Prioritet', ru: 'Приоритет' },
  'common.vip': { en: 'VIP', az: 'VIP', ru: 'VIP' },
  'common.standard': { en: 'Standard', az: 'Adi', ru: 'Обычный' },

  // What a desk is doing.
  'common.desk.open': { en: 'Open', az: 'Açıq', ru: 'Открыто' },
  'common.desk.paused': { en: 'Paused', az: 'Fasilədə', ru: 'Пауза' },
  'common.desk.closed': { en: 'Closed', az: 'Bağlı', ru: 'Закрыто' },

  // Whether what the screen shows is current.
  'common.live': { en: 'Live', az: 'Canlı', ru: 'На связи' },
  'common.connecting': { en: 'Connecting', az: 'Qoşulur', ru: 'Подключение' },
  'common.reconnecting': { en: 'Reconnecting', az: 'Yenidən qoşulur', ru: 'Переподключение' },

  // Durations, short, as a clock on a busy screen shows them.
  'common.durSec': { en: '{s}s', az: '{s} san', ru: '{s} с' },
  'common.durMinSec': { en: '{m}m {s}s', az: '{m} dəq {s} san', ru: '{m} мин {s} с' },
  'common.durHourMin': { en: '{h}h {m}m', az: '{h} saat {m} dəq', ru: '{h} ч {m} мин' },
  // A duration that is a whole number of minutes by what sets it — a service's
  // time limit, which is a minutes field (catalog.Service.ServiceTimeLimitMin) —
  // rather than by rounding: appending ":00" the way durMinSec does would say a
  // limit set to five minutes is "5m 00s", which reads as a precision nobody
  // typed.
  'common.durMin': { en: '{m} min', az: '{m} dəq', ru: '{m} мин' },
} satisfies Record<`common.${string}`, Phrase>
